import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Seo } from '@/components/common/Seo';
import { FadeIn } from '@/components/common/FadeIn';
import { PageHero } from '@/components/common/PageHero';
import { OphirButton } from '@/components/common/OphirButton';
import { useContent } from '@/context/ContentContext';

export default function Categories() {
  const { content } = useContent();
  const seo = content?.seo?.categories;
  const categories = content?.categories || [];
  return (
    <>
      <Seo title={seo?.title} description={seo?.description} />
      <PageHero
        label="Product categories"
        title="Products we source and distribute"
        intro="OPHIR SUPPLY works across a considered range of consumer and commercial product categories. Every opportunity is evaluated for quality, market suitability and documentation."
      />

      <section className="bg-white">
        <div className="container-ophir py-16 lg:py-24">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {categories.map((cat, i) => (
              <FadeIn key={cat.slug} delay={(i % 3) * 0.05}>
                <Link
                  to={`/categories/${cat.slug}`}
                  data-testid={`category-card-${cat.slug}`}
                  className="group block h-full rounded-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ophir-gold focus-visible:ring-offset-2"
                >
                  <article className="h-full bg-ophir-ivory-soft border border-ophir-grey rounded-2xl overflow-hidden shadow-ophir group-hover:shadow-ophir-hover group-hover:border-ophir-gold/50 transition-shadow duration-200">
                    <div className="aspect-[16/10] overflow-hidden bg-ophir-ivory">
                      <img src={cat.image} alt={`${cat.title} — unbranded product still life`} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                    </div>
                    <div className="p-6">
                      <h2 className="flex items-center justify-between gap-2 font-serif text-[20px] text-ophir-navy-deep">
                        <span>{cat.title}</span>
                        <ArrowUpRight size={18} className="shrink-0 text-ophir-grey-med transition-colors duration-200 group-hover:text-ophir-gold-deep" />
                      </h2>
                      <p className="mt-2 text-[15px] leading-relaxed text-ophir-muted">{cat.blurb}</p>
                    </div>
                  </article>
                </Link>
              </FadeIn>
            ))}
          </div>
          <div className="mt-12 rounded-2xl border border-ophir-grey bg-ophir-ivory-soft p-6 text-[13.5px] leading-relaxed text-ophir-muted">
            All product opportunities are subject to commercial review, market suitability, supplier approval, documentation, regulatory requirements, inventory availability and agreed purchasing terms.
          </div>
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <OphirButton to="/suppliers">Submit Your Brand</OphirButton>
            <OphirButton variant="secondary" to="/buyers">Make a Buyer Inquiry</OphirButton>
          </div>
        </div>
      </section>
    </>
  );
}
